<template>
    <modal :name="propsName" width="100%" height="auto" :max-width="800" :max-height="700" :adaptive="true"
        styles="background: rgba(255, 255, 255, .85); border-radius: 10px;" :click-to-close="false">
        <div class="modal modal-confirm">
            <div class="modal-content">
                <a href="javascript:void(0);" class="bt-modal-close bt" data-iziModal-close=".modal-detail-1">
                    <img :src="`@/${getIcoModalClosePath()}`" alt="" v-on:click="hideAndGoHome"/>
                </a>
                <p class="order-modal-header">下記のカテゴリから選択してください</p><br>
                <p class="font-bold-text">＜ご注文前にご確認ください＞</p>
                <p class="sub-text">複数のカテゴリよりご注文いただいた場合でも、カテゴリ別に発送されます。<br>
                    また、送料の条件がカテゴリによって異なりますので、予めご了承ください。詳細は、各ページをご覧ください。</p>
                <div>
                    <div v-if="!displayItems.includes(itemNone)" class="order-modal-img-area">
                        <div v-for="item in displayItems" :key="item" class="order-item-menu-column">
                            <div v-if="canSelectItemType(item) && item !== itemNameWebShop">                                
                                <img v-if="item !== itemNameWebShop && item == itemNameRestylane"
                                src="../../static/img/レスチレン発注フォームアイコン.png" 
                                v-on:click="toOrderForm(productTypeRestylane)" />

                                <img v-if="item !== itemNameWebShop && item == itemNameConsumables"
                                src="../../static/img/各種消耗品発注フォームアイコン.png" 
                                v-on:click="toOrderForm(productTypeConsumables)" />

                                <img v-if="item !== itemNameWebShop && item == itemNamePamphletAndPoster"
                                src="../../static/img/院内ツール発注フォームアイコン.png" 
                                v-on:click="toOrderForm(productTypePamphletAndPoster)" />

                                <img v-if="item !== itemNameWebShop && item == itemNameMiradry"
                                src="../../static/img/各種消耗品発注フォームアイコン.png" 
                                v-on:click="toOrderForm(productTypeMiradry)" />

                                <img v-if="item !== itemNameWebShop && item == itemNameSofwave"
                                src="../../static/img/Sofwaveパルス_発注フォーム.png" 
                                v-on:click="toOrderForm(productTypeSofwave)" />                                
                            
                                <p class="order-modal-img-area-text">{{item}}</p>
                            </div>

                            <div v-if="item == itemNameWebShop">
                                <a href="https://jmec-webshop.jp/mypage/member_login.php" target="_blank" class="bt"><img src="../../static/img/WEB SHOP発注フォームアイコン.png" /></a>
                                <div class="order-modal-img-area-text">
                                    <p>化粧品・美顔器など</p>
                                    <p class="sub-text">(外部サイトへ遷移します)</p>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>
            </div>
            <!--/.modal-content-->
        </div>
        <!--/.modal-->
    </modal>
</template>
<script>
import DeliveryMethods from '../mixins/delivery-methods'
export default {
    name: 'OrderFormModal',
    props: {
        propsName: String, // ヘッダーとサイドバーとバナーで重複表示を避けるため        
        propsDisplayItems: Array      
    },
    data () {
        return {                     
            createItemCnt: 2,
            currentItemCnt: 0,
            itemNone: DeliveryMethods.DISPLAY_ITEM_LIST.NONE,
            itemNameSofwave: DeliveryMethods.DISPLAY_ITEM_LIST.SOFWAVE,
            itemNameRestylane: DeliveryMethods.DISPLAY_ITEM_LIST.RESTYLANE,
            itemNameConsumables: DeliveryMethods.DISPLAY_ITEM_LIST.CONSUMABLES,
            itemNamePamphletAndPoster: DeliveryMethods.DISPLAY_ITEM_LIST.PAMPHLET_POSTER,
            itemNameMiradry: DeliveryMethods.DISPLAY_ITEM_LIST.MIRADRY,
            itemNameWebShop: DeliveryMethods.DISPLAY_ITEM_LIST.WEBSHOP,
            
            productTypeRestylane: DeliveryMethods.PRODUCT_ITEM_TYPE.RESTYLANE,
            productTypeConsumables: DeliveryMethods.PRODUCT_ITEM_TYPE.CONSUMABLES,
            productTypePamphletAndPoster: DeliveryMethods.PRODUCT_ITEM_TYPE.PAMPHLET_POSTER,
            productTypeMiradry: DeliveryMethods.PRODUCT_ITEM_TYPE.MIRADRY,
            productTypeSofwave: DeliveryMethods.PRODUCT_ITEM_TYPE.SOFWAVE,
        }
    },   
    computed: {
        displayItems: {
            get () {
                return this.propsDisplayItems;
            }            
        }
    },
    methods: {
                        
        show() {
            this.disablePageScroll();
            this.$modal.show(this.propsName);            
        },
        hide() {
            this.enablePageScroll();
            this.$modal.hide(this.propsName);
        },
        hideAndGoHome() {
            this.hide();
            this.$router.replace('/home');
        },
        toOrderForm(orderType) {        
            this.$emit("selectOrderItem", orderType);             
        },
        /**
         * 表示できる商品種別に判定を行う
         * @param itemName 商品種別名
         */
        canSelectItemType (itemName) {
            switch (itemName) {
                case this.itemNameSofwave:
                case this.itemNameConsumables:
                case this.itemNamePamphletAndPoster:
                    return true;
                default:
                    return false;                
            }
        }   
    }
}
</script>
  


// WEBPACK FOOTER //
// src/components/OrderFormModal.vue